import isPlainObject from '../utility/isPlainObject';

/**
 * Transforms an object's snake_case properties to camelCase deeply
 * @param {object} params
 * @returns {object} Transformed object with camelCase properties
 */
export default function transformToCamelCase(params) {
  if (Array.isArray(params)) {
    return params.map(transformToCamelCase);
  }
  if (!isPlainObject(params)) {
    return params;
  }
  const transformedParams = {};

  const keys = Object.keys(params);

  for (const key of keys) {
    const finalKey = key.replace(/_(.)/g, ([, char]) => char.toUpperCase());

    if (isPlainObject(params[key])) {
      transformedParams[finalKey] = transformToCamelCase(params[key]);
    } else if (Array.isArray(params[key])) {
      transformedParams[finalKey] = params[key].map(transformToCamelCase);
    } else {
      transformedParams[finalKey] = params[key];
    }
  }

  return transformedParams;
}
